import React from 'react';
import { AppStoreBadge } from '../AppStoreBadge';
import { footerGroups, footerSocials, footerStyles as s } from '../../data/footer';

export function Footer() {
  return <footer style={s.root}>
    <div style={s.intro}>
      <div><p style={s.brand}>Bhol</p><nav aria-label="Social media" style={s.socials}>
        {footerSocials.map(link => <a key={link.label} href={link.href} style={s.social} target="_blank" rel="noopener noreferrer">{link.label}</a>)}
      </nav></div>
      <div style={s.download}><p style={s.downloadTitle}>Let’s get talking.</p><AppStoreBadge location="footer_product" /></div>
    </div>
    <div style={s.grid}>{footerGroups.map(group => <nav key={group.title} aria-label={group.title}>
      <h2 style={s.heading}>{group.title}</h2>
      <div style={group.title === 'Learn' ? s.learnLinks : s.links}>{group.links.map(link => <a key={link.href} href={link.href} style={s.link}>{link.label}</a>)}</div>
    </nav>)}</div>
    <div style={s.bottom}>© 2026 Bhol. All rights reserved.</div>
  </footer>;
}
export default Footer;
